module.exports = __webpack_public_path__ + "img/interface OneB Player_1 prew.3e63c35a.jpg";